import ReactDOM from 'react-dom';
import React from 'react';
import {getTermsOfUse} from 'api/info.jsx';
import IntlWrapper from 'components/layout/intlWrapper';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import events from 'lib/events';

// Libs
import router from '../../lib/router.js';
// Register in router
let isMounted = false;
let render = container => {
  if(!isMounted) {
    console.info('[UI.page.terms-of-service] rendering page');
    ReactDOM.render(<IntlWrapper><TermsOfService /></IntlWrapper>, container);
  }
};

console.info('[UI.page.terms-of-service] register route');
router.rr.add([{path: 'terms-of-service/:sub', handler: render}]);
router.rr.add([{path: 'terms-of-service', handler: render}]);

// helper
const replaceAll = (target, search, replacement) => target.split(search).join(replacement);

// Page object
class TermsOfService extends React.Component {
  static displayName = 'TermsOfService';
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {loading: true, article: ''};

  componentWillMount() {
    this.fetchData();
    this.unsub = events.subscribe('set.language', this.fetchData);
  }

  componentWillUnmount() {
    if (this.unsub && this.unsub.remove) {
      this.unsub.remove();
    }
  }

  fetchData = () => getTermsOfUse(this.props.intl.locale)
    .then(x => this.setState({article: x, loading: false}))
    .catch(err => {
      console.error(err);
      this.setState({loading: false});
    });

  render() {
    if (!this.state.loading && !this.state.article) {
      return <div className='container'>
        <h1><FormattedMessage id="general.terms.use"/></h1>
        <p><FormattedMessage id='article.load.failed' /></p>
      </div>;
    }

    let txt = replaceAll(this.state.article, 'name="', 'name="terms-of-service/');

    txt = replaceAll(txt, 'href="#', 'href="#terms-of-service/');
    const article = {
      __html: txt,
    };

    return <div className='container'>
      <h1><FormattedMessage id="general.terms.use"/></h1>
      <div dangerouslySetInnerHTML={article}/>
    </div>;
  }
}

export default injectIntl(TermsOfService);
